import { Map as IMap } from 'immutable';
import { CPF_NUMBER_FIELD } from '../constants/constants';


export const CART_STATUS = {
    PROCESSING: 'processing',
    READY: 'ready'
};


export const SET_CART_STATUS = '@@storefront/SET_CART_STATUS';
export const SET_CART_CUSTOM_PROMO = '@@storefront/SET_CART_CUSTOM_PROMO';
export const SET_IS_CART_EDITED = '@@storefront/SET_IS_CART_EDITED';
export const SET_OFFER_SECTION_LOADING = '@@storefront/SET_OFFER_SECTION_LOADING';
export const SET_CPF_NUMBER_FIELD = '@@storefront/SET_CPF_NUMBER_FIELD';
export const CLEAR_CPF_NUMBER_FIELD = '@@storefront/CLEAR_CPF_NUMBER_FIELD';


const cartReducer = (state = IMap({ isCartEdited: false, isOfferSectionLoading: false }), action) => {
    switch (action.type) {
        case SET_CART_STATUS: {
            return state.set('cartStatus', action.status);
        }
        case SET_CART_CUSTOM_PROMO: {
            return state.set('cartCustomPromo', action.status);
        }
        case SET_IS_CART_EDITED:
            return state.set('isCartEdited', action.value);
        case SET_OFFER_SECTION_LOADING:
            return state.set('isOfferSectionLoading', action.value);
        case SET_CPF_NUMBER_FIELD: {
            return state.set(CPF_NUMBER_FIELD, action.value);
        }
        case CLEAR_CPF_NUMBER_FIELD: {
            return state.delete(CPF_NUMBER_FIELD);
        }
        default:
    }
    return state;
};



export const setCartStatus = status => ({
    type: SET_CART_STATUS,
    status
});

export function setCartCustomPromo(promoCode) {
    return {
        type: SET_CART_CUSTOM_PROMO,
        status: promoCode
    };
}

export const setIsCartEdited = value => ({
    type: SET_IS_CART_EDITED,
    value
});

export const setOfferSectionLoading = value => ({
    type: SET_OFFER_SECTION_LOADING,
    value
});

export const setCpfNumber = cpfNumber => ({
    type: SET_CPF_NUMBER_FIELD,
    value: cpfNumber
});

export const removeCpfNumber = () => ({
    type: CLEAR_CPF_NUMBER_FIELD
});

export default cartReducer;
